import interceptor from './interceptor';

export interface SlideData {
  PitchDeckId: string;
  ContentInnerHtml?: string;
  SlideTitle: string;
  SlideOrder: number;
  SlideContent: string;
  isActive: boolean;
}

export interface UpdateSlide {
  SlideId: string;
  PitchDeckId: string;
  ContentInnerHtml: string;
  SlideTitle: string;
  SlideContent: string;
  SlideNotes: string;
  SlideType: string;
  SlideBackgoundImage: string;
  SlideBackgroudVideo: string;
  IsActive: boolean;
  SlideOrder: number;
  TrackingCode: string;
  TrackingSnippet: string;
  CreatedDate: string;
  CreatedBy: string;
  ModifiedDate: string;
  ModifiedBy: string;
  DeletedDate: string;
  DeletedBy: string;
}

const getAll = () => {
  const request = interceptor.apiWithAuth.get(
    '/slide/get-all-slides-by-pitchdeckid'
  );
  return request.then(response => response.data);
};

const getAllSlideByPitchdeckId = (pitchDeckId: string) => {
  const request = interceptor.apiWithAuth.get(
    `/slides/by-pitch-deck-id/${pitchDeckId}`
  );
  return request.then(response => response.data);
};
const createMultipleSlides = (slides: SlideData[]) => {
  const request = interceptor.apiWithAuth.post(`/slides/batch`, slides);

  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const updateSlide = (
  slide:
    | UpdateSlide
    | { SlideId: string; IsActive: boolean; PitchDeckId: string }
) => {
  const request = interceptor.apiWithAuth.put(`/slides`, slide);

  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

// const updateSlideBy;

const slidesService = {
  getAll,
  getAllSlideByPitchdeckId,
  createMultipleSlides,
  updateSlide
};
export default slidesService;
